import React, { useState } from "react";
import s from "./Card.module.scss";
import clsx from "clsx";
import Download from "../../../../../../../global components/Icons/Download/Download";

import ReusableModal from "../../../../../../../global components/Modal/Modal";
import MutateVerification from "../MutateVerification/MutateVerification";
import { Tooltip } from "antd";

type CardProp = {
  id: string | undefined;
  userId: string | null;
  status: string | undefined;
  text: string | undefined;
  nameOfDoc: string | undefined;
  src: string | string[] | undefined;
  mutate?: () => void;
};
function Card({ src, nameOfDoc, status, text, id, userId, mutate }: CardProp) {
  const [showModal, setShowModal] = useState<boolean>(false);

  const handleModal = () => {
    setShowModal((prev) => !prev);
  };
  return (
    <>
      <ReusableModal
        centered
        width={"584px"}
        styles={{
          content: {
            padding: 0,
            overflowY: "auto",
          },
          header: {
            padding: "12px 24px 12px 24px",
          },
          body: {
            padding: "0px 24px 0px 24px",
          },
        }}
        title={""}
        handleModal={handleModal}
        isModalOpen={showModal}
      >
        <MutateVerification
          status={status || ""}
          src={src}
          mutate={mutate}
          handleModal={handleModal}
          documentId={id}
          userId={userId}
        />
      </ReusableModal>
      <div className={s.wrapper}>
        <div className={s.img}>
          {typeof src === "string" ? (
            <Tooltip title="Verify document">
              <img onClick={handleModal} src={src} alt="user document" />
            </Tooltip>
          ) : (
            <Tooltip title="Verify document">
              <img
                onClick={handleModal}
                src={(src && src[0]) || ""}
                alt="user document"
              />
            </Tooltip>
          )}
        </div>
        <div className={s.footer}>
          <span className={s.texts}>
            <h2 className={s.nameOfDoc}>{nameOfDoc}</h2>
            <h3
              className={clsx(
                s.text,
                s.statusCell,
                status &&
                  s[
                    status === "pending"
                      ? "pending"
                      : status === "rejected"
                        ? "failed"
                        : "successful"
                  ],
              )}
            >
              {text && text.charAt(0).toUpperCase() + text.slice(1)}
            </h3>
          </span>
          <div className={s.downloadBtn}>
            {typeof src === "string" ? (
              <Tooltip title="View document">
                <a
                  href={src}
                  target="_blank"
                  rel="noopener noreferrer"
                  download="Document.pdf"
                >
                  <Download />
                </a>
              </Tooltip>
            ) : (
              src?.map((item, index) => (
                <Tooltip title={`View document ${index + 1}`} key={item}>
                  <a
                    href={item}
                    target="_blank"
                    rel="noopener noreferrer"
                    download="Document.pdf"
                  >
                    <Download />
                  </a>
                </Tooltip>
              ))
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Card;
